import { render } from "./Interest.vue?vue&type=template&id=98c9ff08"
import script from "./Interest.vue?vue&type=script&lang=js"
export * from "./Interest.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__